(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contadorR"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function init(el) {
      if (el.dataset.countdownInit === 'true') return;
      el.dataset.countdownInit = 'true';

      var target = new Date(el.dataset.countdownDate).getTime();
      var showDays = el.dataset.showDays === 'true';
      var hideOnEnd = el.dataset.hideOnEnd === 'true';
      /* Reinicio: al llegar a cero vuelve a contar N horas, una y otra vez */
      var ciclo = (+el.dataset.repetir || 0) * 3600000;
      var clock = el.querySelector('[data-countdown-clock]');
      var expired = el.querySelector('[data-countdown-expired]');
      var bar = el.closest('.abc') || el;
      var desde = +(bar.dataset.desde || 0) * 1000;
      var oculta = bar.style.display === 'none';
      /* El header calcula su posición con el alto de la barra: avisarle */
      function mostrar(si) {
        if (oculta === !si) return;
        oculta = !si;
        bar.style.display = si ? '' : 'none';
        window.dispatchEvent(new Event('resize'));
      }

      var fields = {
        days: el.querySelector('[data-days]'),
        hours: el.querySelector('[data-hours]'),
        minutes: el.querySelector('[data-minutes]'),
        seconds: el.querySelector('[data-seconds]')
      };

      var interval = null;

      function render() {
        if (isNaN(target)) {
          if (interval) clearInterval(interval);
          return;
        }
        if (desde && Date.now() < desde) { mostrar(false); return; }
        var diff = target - Date.now();
        if (diff <= 0 && ciclo > 0) {
          /* Salta al siguiente fin de ciclo: fin original + k × ciclo */
          target += Math.ceil((1 - diff) / ciclo) * ciclo;
          diff = target - Date.now();
        }

        if (diff <= 0) {
          if (interval) clearInterval(interval);
          if (hideOnEnd && bar) {
            mostrar(false);
          } else {
            if (clock) clock.style.display = 'none';
            if (expired) expired.hidden = false;
          }
          return;
        }

        mostrar(true);
        var totalHours = Math.floor(diff / 3600000);
        var days = Math.floor(diff / 86400000);
        var hours = showDays ? Math.floor((diff % 86400000) / 3600000) : totalHours;
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        if (showDays && fields.days) fields.days.textContent = pad(days);
        if (fields.hours) fields.hours.textContent = pad(hours);
        if (fields.minutes) fields.minutes.textContent = pad(minutes);
        if (fields.seconds) {
          fields.seconds.textContent = pad(seconds);
          /* Reiniciar la animación del segundo en cada tic */
          fields.seconds.classList.remove('is-tick');
          void fields.seconds.offsetWidth;
          fields.seconds.classList.add('is-tick');
        }
      }

      render();
      interval = setInterval(render, 1000);
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-countdown-bar]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
